export enum FeatureFlag {
  ALERTS_ACCESS = 'alerts-access',
  ALLOWED_CUSTOM_COLUMNS = 'allowed-custom-columns',
  ALLOWED_CUSTOM_REPORTS = 'allowed-custom-reports',
  ALLOWED_TO_EDIT_ADMIN_TEAMS = 'allowed-to-edit-admin-teams',
  ALLOWED_TO_VIEW_ADDONS = 'allowed-to-view-addons',
  ALLOWED_TO_VIEW_PLUGINS = 'allowed-to-view-plugins',
  ALLOWED_TO_VIEW_POLICIES = 'allowed-to-view-policies',
  ALLOWED_TO_VIEW_REPORTS = 'allowed-to-view-dashboards',
  ALLOWED_TO_VIEW_SYNCS = 'allowed-to-view-syncs',
  PLATFORM_DISABLED_PLUGIN_UI = 'platform-disabled-plugin-ui',
  READONLY_USER_EDIT_DISABLED = 'readonly-user-edit-disabled',
  USAGE_ACCESS = 'usage-access',
}

export const localFeatureFlagValues = {
  [FeatureFlag.ALLOWED_TO_VIEW_ADDONS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_PLUGINS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_SYNCS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_VIEW_POLICIES]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_CUSTOM_COLUMNS]: {
    editing: process.env.NODE_ENV === 'development' ? true : false,
    enabled: process.env.NODE_ENV === 'development' ? true : false,
    externals: process.env.NODE_ENV === 'development' ? true : false,
  },
  [FeatureFlag.ALLOWED_CUSTOM_REPORTS]: {
    creating: process.env.NODE_ENV === 'development' ? true : false,
    editing: process.env.NODE_ENV === 'development' ? true : false,
  },
  [FeatureFlag.ALLOWED_TO_VIEW_REPORTS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALLOWED_TO_EDIT_ADMIN_TEAMS]:
    process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.USAGE_ACCESS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.ALERTS_ACCESS]: process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.READONLY_USER_EDIT_DISABLED]:
    process.env.NODE_ENV === 'development' ? 'true' : 'false',
  [FeatureFlag.PLATFORM_DISABLED_PLUGIN_UI]: '',
} as const;
